const TOPIC_LABELS = {
  France: { en: "France", cn: "法国" },
  Bordeaux: { en: "Bordeaux", cn: "波尔多" },
  Burgundy: { en: "Burgundy", cn: "勃艮第" },
  Loire: { en: "Loire", cn: "卢瓦尔河谷" },
  Rhone: { en: "Rhône", cn: "罗纳河谷" },
  Alsace: { en: "Alsace", cn: "阿尔萨斯" },
  Jura: { en: "Jura", cn: "汝拉" },
  "Southern France": { en: "Southern France", cn: "法国南部" },
  Germany: { en: "Germany", cn: "德国" },
  Australia: { en: "Australia", cn: "澳大利亚" },
  NewZealand: { en: "New Zealand", cn: "新西兰" },
  Spain: { en: "Spain", cn: "西班牙" },
  Portugal: { en: "Portugal", cn: "葡萄牙" },
  USA: { en: "USA", cn: "美国" },
  California: { en: "California", cn: "加州" },
  SouthAfrica: { en: "South Africa", cn: "南非" },
  Italy: { en: "Italy", cn: "意大利" },
  "Northern East": { en: "North-East Italy", cn: "意大利东北部" },
  "Central Italy": { en: "Central Italy", cn: "意大利中部" },
  "Southern Italy": { en: "Southern Italy", cn: "意大利南部" },
  Chile: { en: "Chile", cn: "智利" },
  Argentina: { en: "Argentina", cn: "阿根廷" },
  Greece: { en: "Greece", cn: "希腊" },
  Chardonnay: { en: "Chardonnay", cn: "霞多丽" },
  "Pinot Noir": { en: "Pinot Noir", cn: "黑皮诺" },
  "Cabernet Sauvignon": { en: "Cabernet Sauvignon", cn: "赤霞珠" },
  Merlot: { en: "Merlot", cn: "梅洛" },
  Grenache: { en: "Grenache", cn: "歌海娜" },
  Malbec: { en: "Malbec", cn: "马尔贝克" },
  Syrah: { en: "Syrah", cn: "西拉" },
  Riesling: { en: "Riesling", cn: "雷司令" },
  "Sauvignon Blanc": { en: "Sauvignon Blanc", cn: "长相思" },
  "Pinot Grigio": { en: "Pinot Grigio / Pinot Gris", cn: "灰皮诺" },
  "Cabernet Franc": { en: "Cabernet Franc", cn: "品丽珠" },
};

const GRAPE_ALIASES = {
  Syrah: ["Syrah", "Shiraz"],
  Grenache: ["Grenache", "Garnacha", "Cannonau"],
  "Pinot Grigio": ["Pinot Grigio", "Pinot Gris"],
  "Cabernet Sauvignon": ["Cabernet Sauvignon", "Cabernet"],
  Tempranillo: ["Tempranillo", "Tinta Roriz", "Aragonez"],
  "Pinot Noir": ["Pinot Noir", "Spätburgunder"],
};

const GRAPE_PROFILES = {
  Chardonnay: {
    en: "Chardonnay is a neutral, early- to mid-ripening white with medium acidity and medium body; flavours range from green apple and citrus in cool sites to stone fruit and tropical notes when riper.",
    cn: "霞多丽是中性、早至中熟的白葡萄，酸度中等、酒体中等；凉爽产区呈青苹果和柑橘风味，更成熟时则有核果和热带水果香气。",
  },
  "Pinot Noir": {
    en: "Pinot Noir is thin-skinned, early-ripening, pale in colour, with low to medium tannin, high acidity and red-fruit (strawberry, cherry), floral and earthy notes. It is fragile in the vineyard and needs a cool to moderate climate.",
    cn: "黑皮诺果皮薄、早熟、颜色浅，单宁低至中等、酸度高，带有草莓、樱桃等红果、花香和泥土气息。种植敏感，需要凉爽至温和气候。",
  },
  "Cabernet Sauvignon": {
    en: "Cabernet Sauvignon is thick-skinned and late-ripening, with high tannin, high acidity, deep colour and blackcurrant, cedar and herbaceous notes if underripe. It needs warmth and a long season to ripen fully.",
    cn: "赤霞珠果皮厚、晚熟，单宁高、酸度高、颜色深，带有黑醋栗、雪松香；未完全成熟时会有草本味。需要温暖气候和较长生长季才能充分成熟。",
  },
  Merlot: {
    en: "Merlot is thinner-skinned and earlier-ripening than Cabernet Sauvignon, with medium tannin, medium acidity, a plush texture and plum, blackberry and chocolate flavours. In warm climates it can become jammy and high in alcohol.",
    cn: "梅洛果皮较薄、比赤霞珠更早熟，单宁中等、酸度中等，口感柔顺，带有李子、黑莓和巧克力风味。温暖气候下容易呈现果酱感和较高酒精度。",
  },
  Grenache: {
    en: "Grenache is thin-skinned, drought- and heat-tolerant, with low to medium tannin, low to medium acidity, high alcohol and ripe red-fruit, spice and sometimes white-pepper notes. It oxidises easily and is often blended for colour and structure.",
    cn: "歌海娜果皮薄、耐旱耐热，单宁低至中等、酸度偏低、酒精度高，带有成熟红果、香料和有时白胡椒风味。易氧化，常通过混酿补充颜色与结构。",
  },
  Malbec: {
    en: "Malbec is deep-coloured, with medium to high tannin that is typically ripe and velvety, medium acidity and flavours of blackberry, plum and violet. High-altitude sites keep freshness; warmer sites give riper, fuller styles.",
    cn: "马尔贝克颜色深，单宁中高但通常成熟丝滑，酸度中等，带有黑莓、李子和紫罗兰香气。高海拔产区更清新，温暖产区更成熟饱满。",
  },
  Syrah: {
    en: "Syrah (Shiraz) is thick-skinned, with high tannin, deep colour, medium to high acidity and black fruit, violet and black-pepper notes. It needs sufficient warmth to ripen; overripe fruit becomes stewed and jammy.",
    cn: "西拉（设拉子）果皮厚、单宁高、颜色深、酸度中高，带有黑色水果、紫罗兰和黑胡椒。需要足够热量才能成熟；过熟则呈炖煮和果酱感。",
  },
  Riesling: {
    en: "Riesling is aromatic, high in acidity, light to medium-bodied, with citrus, stone fruit, floral and petrol notes with age. It expresses site clearly and can be made dry through to lusciously sweet.",
    cn: "雷司令芳香、酸度高、酒体轻至中等，带有柑橘、核果、花香，陈年后有石油气息。能清晰表达园地，风格可从干型到极甜。",
  },
  "Sauvignon Blanc": {
    en: "Sauvignon Blanc is aromatic, high in acidity, light to medium-bodied, with green apple, citrus, grass and passion fruit. It is early-ripening and shows pyrazines (green notes) if underripe.",
    cn: "长相思芳香、酸度高、酒体轻至中等，带有青苹果、柑橘、青草和百香果。较早成熟，未完全成熟时会有青椒/草本的吡嗪类气息。",
  },
  "Pinot Grigio": {
    en: "Pinot Grigio / Pinot Gris is pink-skinned, early-ripening, with low to medium acidity. Italian Pinot Grigio is typically light, citrus and pear; Alsace Pinot Gris is riper, fuller and more spicy/textural.",
    cn: "灰皮诺果皮粉红、早熟，酸度低至中等。意大利灰皮诺通常轻盈、柑橘和梨香；阿尔萨斯灰皮诺更成熟、更饱满，带香料和质感。",
  },
  "Cabernet Franc": {
    en: "Cabernet Franc is earlier-ripening than Cabernet Sauvignon, with medium tannin, high acidity, red fruit and leafy/pencil-shaving notes. It retains freshness in cool climates such as the Loire.",
    cn: "品丽珠比赤霞珠更早熟，单宁中等、酸度高，带有红果和草本/铅笔屑气息。在卢瓦尔等凉爽气候中能保持清新。",
  },
  Assyrtiko: {
    en: "Assyrtiko is high in acidity even at high ripeness, with citrus, stone fruit and pronounced minerality, often moderate to high alcohol and a firm, age-worthy structure.",
    cn: "阿斯提可即使高度成熟仍保持高酸，带有柑橘、核果和明显矿物感，酒精度常为中高，结构紧实、具陈年潜力。",
  },
  Xinomavro: {
    en: "Xinomavro is high in acidity and tannin, often pale to medium in colour, with tomato, olive, red fruit and dried-herb notes when mature; it needs careful ripening and ageing.",
    cn: "西诺玛芙罗酸度高、单宁高，颜色常浅至中等，成熟后有番茄、橄榄、红果和干香草气息；需要充分成熟和适当陈年。",
  },
  Agiorgitiko: {
    en: "Agiorgitiko is typically lower in acidity and softer in tannin than Xinomavro, with ripe red fruit and a rounder, more approachable profile; higher sites keep more freshness.",
    cn: "阿吉欧吉提可比西诺玛芙罗酸度更低、单宁更柔和，带有成熟红果，口感更圆润易饮；高海拔产区更清新。",
  },
  Moschofilero: {
    en: "Moschofilero is pink-skinned, highly aromatic (rose, spice, citrus), high in acidity and usually light-bodied; high-altitude sites such as Mantinia preserve freshness and perfume.",
    cn: "莫斯霍菲莱罗果皮粉红、极芳香（玫瑰、香料、柑橘），酸度高、酒体通常较轻；曼蒂尼亚等高海拔产区能保留清新与香气。",
  },
  Savatiano: {
    en: "Savatiano is drought-resistant, typically moderate in acidity and relatively neutral, used for fresh still wines and Retsina; low yields and careful winemaking can give more texture.",
    cn: "萨瓦提亚诺耐旱，酸度中等、相对中性，用于清新静止酒和松脂酒；低产和精细酿造可增加质感。",
  },
  Malagousia: {
    en: "Malagousia is an aromatic Greek white with stone fruit, citrus and floral notes, medium to high acidity and a relatively full texture for an aromatic variety.",
    cn: "马拉古西亚是芳香型希腊白葡萄，带有核果、柑橘和花香，酸度中高，在芳香品种中质感相对饱满。",
  },
  Sangiovese: {
    en: "Sangiovese has high acidity, medium to high tannin, medium colour and sour cherry, herbal and savoury notes. It needs warmth to ripen but cool nights to keep acidity.",
    cn: "桑娇维塞酸度高、单宁中高、颜色中等，带有酸樱桃、草本和咸鲜风味。需要温暖才能成熟，同时需要凉爽夜间以保留酸度。",
  },
  Nebbiolo: {
    en: "Nebbiolo is very high in tannin and acidity, pale in colour, with tar, rose, cherry and dried-herb notes. It needs a long growing season and extended ageing to resolve tannin.",
    cn: "内比奥罗单宁和酸度都极高，颜色浅，带有焦油、玫瑰、樱桃和干香草。需要长生长季和长时间陈年来柔化单宁。",
  },
  Tempranillo: {
    en: "Tempranillo is medium in acidity and tannin, with strawberry, plum and leather notes; it is relatively early-ripening and takes oak well.",
    cn: "丹魄酸度和单宁中等，带有草莓、李子和皮革气息；相对早熟，适合橡木桶陈酿。",
  },
  CheninBlanc: {
    en: "Chenin Blanc is high in acidity, versatile in sweetness, with apple, quince and honey notes and a waxy texture; it can be still, sparkling or sweet.",
    cn: "白诗南酸度高、甜度风格多样，带有苹果、温柏和蜂蜜气息，质感偏蜡质；可做静止、起泡或甜酒。",
  },
  Viognier: {
    en: "Viognier is low to medium in acidity, full-bodied and highly aromatic (apricot, blossom), with high alcohol if fully ripe; it oxidises easily.",
    cn: "维欧尼酸度低至中等、酒体饱满、极芳香（杏、花香），完全成熟时酒精度高，且容易氧化。",
  },
};

GRAPE_PROFILES["Chenin Blanc"] = GRAPE_PROFILES.CheninBlanc;

const CLIMATE_RE = /climate|climatic|temperature|altitude|maritime|continental|drought|frost|wind|rainfall|cool|warm|hot|lake|sea|ocean|fog|diurnal|humidity|hazard|meltemi/i;
const SOIL_RE = /soil|limestone|clay|granite|schist|volcanic|gravel|sand|phylloxera|slate|alluvial/i;
const VIT_RE = /viticult|training|harvest|yield|irrigation|canopy|pruning|ripeness|phenolic|planting|density|kouloura|machine/i;
const WM_RE = /oak|ageing|aging|ferment|maceration|fortif|lees|malolactic|barrel|sparkling|drying|sun-dried|carbonic|blend|winemaking|destem|whole bunch|barrique/i;
const VAR_RE = /grape|variety|varieties|pdo|aoc|doc|doq|principal|permitted|sole|indigenous/i;
const CHAR_RE = /aroma|flavour|flavor|tannin|acid|body|colour|color|characteristic|ripen|skin|texture|associated with|notes of|descriptor/i;

const COMPARISON_PAIRS = [
  [["France", "Bordeaux"], ["France", "Burgundy"]],
  [["France", "Loire"], ["France", "Rhone"]],
  [["France", "Alsace"], ["Germany"]],
  [["Italy", "Northern East"], ["Italy", "Southern Italy"]],
  [["USA", "California"], ["Australia"]],
  [["Chile"], ["Argentina"]],
  [["NewZealand"], ["SouthAfrica"]],
  [["Spain"], ["Portugal"]],
  [["Grapes", "Cabernet Sauvignon"], ["Grapes", "Merlot"]],
  [["Grapes", "Pinot Noir"], ["Grapes", "Syrah"]],
  [["Grapes", "Sauvignon Blanc"], ["Grapes", "Riesling"]],
  [["Grapes", "Chardonnay"], ["Grapes", "Sauvignon Blanc"]],
];

const labelOf = (key) => TOPIC_LABELS[key] || { en: key, cn: key };

const topicName = (path) => {
  const keys = path.filter((p) => p !== "Grapes");
  const labels = keys.map(labelOf);
  if (labels.length === 1) return labels[0];
  const region = labels[labels.length - 1];
  const country = labels[0];
  return {
    en: `${region.en}, ${country.en}`,
    cn: `${country.cn}${region.cn}`,
  };
};

const pathKey = (path) => path.join("/");

const collectTopics = (questionFiles) => {
  const topics = [];
  const walk = (node, path) => {
    if (Array.isArray(node)) {
      if (node.length > 0) topics.push({ path, questions: node });
    } else if (node && typeof node === "object") {
      Object.entries(node).forEach(([k, v]) => walk(v, [...path, k]));
    }
  };
  walk(questionFiles, []);
  return topics;
};

const uniqueFacts = (facts) => {
  const seen = new Set();
  return facts.filter((b) => {
    const key = (b?.en || b?.cn || "").toLowerCase().replace(/\s+/g, " ").slice(0, 70);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const qText = (q) =>
  `${q.question?.en || ""} ${(q.answers || []).map((a) => `${a.text?.en || ""} ${a.explanation?.en || ""}`).join(" ")}`;

const categorize = (q) => {
  const text = qText(q);
  if (CLIMATE_RE.test(text) || SOIL_RE.test(text)) return "climate";
  if (CHAR_RE.test(text) && !WM_RE.test(text)) return "character";
  if (VIT_RE.test(text) && !WM_RE.test(text)) return "viticulture";
  if (WM_RE.test(text)) return "winemaking";
  if (VAR_RE.test(text)) return "variety";
  return "style";
};

const aliasList = (name) => GRAPE_ALIASES[name] || [name];

const detectGrapes = (...texts) => {
  const blob = texts.filter(Boolean).join(" ").toLowerCase();
  const found = [];
  Object.keys(GRAPE_PROFILES)
    .sort((a, b) => b.length - a.length)
    .forEach((name) => {
      if (aliasList(name).some((alias) => blob.includes(alias.toLowerCase()))) {
        found.push(name);
      }
    });
  if (found.includes("Cabernet Franc") && !blob.includes("cabernet sauvignon")) {
    return found.filter((n) => n !== "Cabernet Sauvignon");
  }
  return found;
};

const GRAPE_KEYS = {
  Chardonnay: { en: "Chardonnay: medium acid, apple–citrus or stone/tropical fruit", cn: "霞多丽：中酸；青苹果/柑橘或核果/热带水果" },
  "Pinot Noir": { en: "Pinot Noir: thin skin, pale, low–medium tannin, high acid, red fruit", cn: "黑皮诺：薄皮、色浅、低–中单宁、高酸、红果" },
  "Cabernet Sauvignon": { en: "Cabernet Sauvignon: thick skin, high tannin & acid, blackcurrant, late-ripening", cn: "赤霞珠：厚皮、高单宁高酸、黑醋栗、晚熟" },
  Merlot: { en: "Merlot: medium tannin & acid, plum/chocolate, earlier-ripening, plush", cn: "梅洛：中单宁中酸、李子/巧克力、较早熟、口感柔顺" },
  Grenache: { en: "Grenache: heat-tolerant, low–medium tannin & acid, high alcohol, red fruit", cn: "歌海娜：耐热、低–中单宁与酸、高酒精度、红果" },
  Malbec: { en: "Malbec: deep colour, ripe velvety tannin, medium acid, blackberry/plum", cn: "马尔贝克：颜色深、单宁成熟丝滑、中酸、黑莓/李子" },
  Syrah: { en: "Syrah: thick skin, high tannin, deep colour, black fruit & pepper", cn: "西拉：厚皮、高单宁、色深、黑色水果与黑胡椒" },
  Riesling: { en: "Riesling: high acid, aromatic, citrus/stone fruit, dry to sweet", cn: "雷司令：高酸、芳香、柑橘/核果，干型到甜型" },
  "Sauvignon Blanc": { en: "Sauvignon Blanc: high acid, grass/citrus/passion fruit", cn: "长相思：高酸、青草/柑橘/百香果" },
  "Pinot Grigio": { en: "Pinot Grigio/Gris: pink skin, low–medium acid; light (IT) or richer (Alsace)", cn: "灰皮诺：粉红皮、低–中酸；意大利轻盈，阿尔萨斯更饱满" },
  "Cabernet Franc": { en: "Cabernet Franc: medium tannin, high acid, red fruit, leafy notes", cn: "品丽珠：中单宁、高酸、红果、草本" },
  Assyrtiko: { en: "Assyrtiko: high acid even when ripe, citrus, mineral, firm structure", cn: "阿斯提可：成熟仍高酸、柑橘、矿物、结构紧实" },
  Xinomavro: { en: "Xinomavro: high acid & tannin, pale, tomato/olive with age", cn: "西诺玛芙罗：高酸高单宁、色浅、陈年后番茄/橄榄" },
  Agiorgitiko: { en: "Agiorgitiko: softer tannin, lower acid than Xinomavro, ripe red fruit", cn: "阿吉欧吉提可：单宁更柔、酸度低于西诺玛芙罗、成熟红果" },
  Moschofilero: { en: "Moschofilero: pink skin, high acid, rose/spice, light body", cn: "莫斯霍菲莱罗：粉红皮、高酸、玫瑰/香料、酒体轻" },
  Savatiano: { en: "Savatiano: drought-resistant, moderate acid, relatively neutral", cn: "萨瓦提亚诺：耐旱、酸度中等、相对中性" },
  Malagousia: { en: "Malagousia: aromatic, stone fruit/citrus/floral, medium–high acid", cn: "马拉古西亚：芳香、核果/柑橘/花香、中高酸" },
  Sangiovese: { en: "Sangiovese: high acid, medium–high tannin, sour cherry, savoury", cn: "桑娇维塞：高酸、中高单宁、酸樱桃、咸鲜" },
  Nebbiolo: { en: "Nebbiolo: very high tannin & acid, pale, tar/rose/cherry", cn: "内比奥罗：极高单宁与酸、色浅、焦油/玫瑰/樱桃" },
  Tempranillo: { en: "Tempranillo: medium acid & tannin, strawberry/plum, takes oak well", cn: "丹魄：中酸中单宁、草莓/李子、适合橡木" },
  "Chenin Blanc": { en: "Chenin Blanc: high acid, apple/quince/honey, dry to sweet/sparkling", cn: "白诗南：高酸、苹果/温柏/蜂蜜，干到甜/起泡" },
  Viognier: { en: "Viognier: low–medium acid, full body, apricot/blossom, high alcohol", cn: "维欧尼：低–中酸、酒体饱满、杏/花香、酒精度高" },
};

const WM_KEYS = {
  Chardonnay: { en: "Winemaking: stainless cool ferment, or barrel + MLF + lees", cn: "酿造：不锈钢低温发酵，或桶发酵 + 苹果酸乳酸发酵 + 酒泥" },
  "Pinot Noir": { en: "Winemaking: gentle extraction, some whole bunch, older oak", cn: "酿造：轻柔浸提、部分整串、旧橡木" },
  "Cabernet Sauvignon": { en: "Winemaking: destem, warm ferment, extended maceration, French oak", cn: "酿造：去梗、温暖发酵、延长浸渍、法国橡木" },
  Merlot: { en: "Winemaking: ferment dry, blend with Cabernet, oak to round", cn: "酿造：发酵至干、与赤霞珠混酿、橡木柔化" },
  Grenache: { en: "Winemaking: often blend with Syrah/Mourvèdre; little new oak", cn: "酿造：常与西拉/慕合怀特混酿；少用新桶" },
  Malbec: { en: "Winemaking: French/American oak to round tannin; less oak at altitude", cn: "酿造：法/美橡木柔化单宁；高海拔少用橡木" },
  Syrah: { en: "Winemaking: stems in cool sites; more new oak in warm Shiraz; Viognier co-ferment", cn: "酿造：凉爽产区可带梗；温暖设拉子多用新桶；可与维欧尼共发酵" },
  Riesling: { en: "Winemaking: cool stainless/old oak, no MLF, optional residual sugar", cn: "酿造：低温不锈钢/旧桶、不做苹果酸乳酸发酵、可留残糖" },
  "Sauvignon Blanc": { en: "Winemaking: cool stainless, protect from oxygen, early bottling", cn: "酿造：不锈钢低温、隔氧、早装瓶" },
  "Pinot Grigio": { en: "Winemaking: early harvest, stainless; richer Gris may use skin contact/oak", cn: "酿造：早收、不锈钢；饱满灰皮诺可浸皮/橡木" },
  "Cabernet Franc": { en: "Winemaking: older oak/large casks; Bordeaux blend with Cabernet/Merlot", cn: "酿造：旧桶/大桶；波尔多与赤霞珠/梅洛混酿" },
  Assyrtiko: { en: "Winemaking: stainless for citrus/mineral; some oak; Vinsanto sun-dried", cn: "酿造：不锈钢保留柑橘矿物；部分橡木；Vinsanto日晒风干" },
  Xinomavro: { en: "Winemaking: oak + bottle age to soften tannin; sparkling in Amyndeon", cn: "酿造：橡木与瓶陈柔化单宁；阿明迪翁可做起泡" },
  Agiorgitiko: { en: "Winemaking: fruity stainless or oak-aged from cooler high sites", cn: "酿造：果味不锈钢，或高海拔凉爽地块橡木陈酿" },
  Moschofilero: { en: "Winemaking: cool stainless, bottle young; some rosé/sparkling", cn: "酿造：不锈钢低温、年轻装瓶；可做桃红/起泡" },
  Sangiovese: { en: "Winemaking: destem, oak (cask or barrique); optional Cabernet/Merlot blend", cn: "酿造：去梗、橡木（大桶或巴里克）；可混赤霞珠/梅洛" },
  Nebbiolo: { en: "Winemaking: long maceration, long large-oak ageing", cn: "酿造：延长浸渍、大桶长期陈酿" },
  Tempranillo: { en: "Winemaking: American/French oak (Crianza–Gran Reserva)", cn: "酿造：美/法橡木（Crianza至Gran Reserva）" },
  "Chenin Blanc": { en: "Winemaking: dry or residual sugar; stainless or old oak; traditional-method sparkling", cn: "酿造：干型或残糖；不锈钢或旧桶；传统法起泡" },
  Viognier: { en: "Winemaking: protect from oxygen; some barrel/lees for texture", cn: "酿造：隔氧；部分桶/酒泥增加质感" },
};

const REGION_WM_KEYS = {
  Bordeaux: { en: "Winemaking: blends, destem, French oak 12–18 months", cn: "酿造：混酿、去梗、法国橡木12–18个月" },
  Burgundy: { en: "Winemaking: single variety; whites barrel + MLF + lees; reds older oak", cn: "酿造：单一品种；白葡萄酒桶+苹果酸乳酸发酵+酒泥；红葡萄酒旧桶" },
  Rhone: { en: "Winemaking: N. Rhône Syrah ± stems/oak; S. Rhône Grenache blends, little new oak", cn: "酿造：北罗纳西拉±带梗/橡木；南罗纳歌海娜混酿，少新桶" },
  Loire: { en: "Winemaking: stainless whites; Cabernet Franc in older oak", cn: "酿造：白葡萄酒不锈钢；品丽珠旧桶" },
  Alsace: { en: "Winemaking: large old cask or stainless, little new oak, often no MLF", cn: "酿造：大旧桶或不锈钢，少新桶，常不做苹果酸乳酸发酵" },
  California: { en: "Winemaking: ripe fruit, often new oak for Cabernet/Chardonnay", cn: "酿造：果实成熟，赤霞珠/霞多丽常用新橡木" },
  Greece: { en: "Winemaking: Assyrtiko often stainless; reds oak-aged; Vinsanto sun-dried", cn: "酿造：阿斯提可常不锈钢；红葡萄酒橡木陈酿；Vinsanto日晒" },
};

const firstSentence = (text) => {
  const t = (text || "").replace(/\s+/g, " ").trim();
  if (!t) return "";
  const m = t.match(/^.+?[.!?。]/);
  const s = (m ? m[0] : t).trim();
  return s.length > 110 ? `${s.slice(0, 107).replace(/\s+\S*$/, "")}…` : s;
};

const shortFact = (q) => {
  const correct = (q.answers || []).find((a) => a.correct);
  if (!correct) return null;
  const take = (lang) => {
    const why = firstSentence(correct.explanation?.[lang] || "");
    const fact = firstSentence(correct.text?.[lang] || "");
    if (why && why.length <= 110) return why.replace(/[.。]$/, "");
    if (fact) return fact.replace(/[.。]$/, "");
    return why.replace(/[.。]$/, "");
  };
  const en = take("en");
  const cn = take("cn");
  if (!en && !cn) return null;
  return { en, cn };
};

const grapeCharBullets = (names) =>
  [...new Set(names)]
    .filter((n) => GRAPE_KEYS[n])
    .slice(0, 3)
    .map((n) => GRAPE_KEYS[n]);

const winemakingBullets = (grapeNames, regionKey) => {
  const out = [];
  [...new Set(grapeNames)].forEach((n) => {
    if (WM_KEYS[n]) out.push(WM_KEYS[n]);
  });
  if (!out.length && regionKey && REGION_WM_KEYS[regionKey]) out.push(REGION_WM_KEYS[regionKey]);
  return out.slice(0, 2);
};

const pushFacts = (bullets, facts, max) => {
  uniqueFacts(facts).slice(0, max).forEach((f) => bullets.push(f));
};

const buildModelAnswer = (questions, context = {}) => {
  const { grapeName, regionKey } = context;
  const grouped = {
    climate: [],
    character: [],
    variety: [],
    viticulture: [],
    winemaking: [],
    style: [],
  };
  (questions || []).forEach((q) => {
    const fact = shortFact(q);
    if (fact) grouped[categorize(q)].push(fact);
  });

  const detected = detectGrapes(
    grapeName,
    regionKey,
    ...(questions || []).map(qText)
  );
  const grapes = [...new Set([grapeName, ...detected].filter((n) => GRAPE_KEYS[n] || GRAPE_PROFILES[n]))];

  const bullets = [];
  pushFacts(bullets, grouped.climate, 2);
  grapeCharBullets(grapes).forEach((b) => bullets.push(b));
  pushFacts(bullets, [...grouped.character, ...grouped.variety], 2);
  pushFacts(bullets, grouped.viticulture, 2);
  pushFacts(bullets, grouped.style, 2);
  pushFacts(bullets, grouped.winemaking, 2);
  winemakingBullets(grapes, regionKey).forEach((b) => bullets.push(b));

  if (bullets.length === 0) {
    return uniqueFacts(Object.values(grouped).flat()).slice(0, 6);
  }
  return uniqueFacts(bullets).slice(0, 8);
};

const makeEssay = (id, topic, question, questions, context = {}) => {
  const bullets = buildModelAnswer(questions, { ...context, topic });
  const cleaned = uniqueFacts(bullets).filter((b) => b.en || b.cn);
  if (cleaned.length === 0) return null;
  return {
    type: "essay",
    id,
    topic,
    question,
    bullets: cleaned,
    answerVersion: 2,
  };
};

const isGrapeTopic = (path) => path[0] === "Grapes";

const factorsQuestion = (topic, grape) =>
  grape
    ? {
        en: `Explain the principal growing requirements, grape characteristics, wine styles and key regions associated with ${topic.en}. Include relevant winemaking options.`,
        cn: `请说明${topic.cn}的主要种植条件、品种特性、葡萄酒风格及重要产区，并涉及相关酿酒选择。`,
      }
    : {
        en: `Explain the key factors that influence the style and quality of wines from ${topic.en}. Your answer should include reference to climate, grape characteristics, viticulture and winemaking as appropriate.`,
        cn: `请说明影响${topic.cn}葡萄酒风格与品质的关键因素。答案应酌情涉及气候、葡萄品种特性、葡萄种植和酿酒工艺。`,
      };

const climateQuestion = (topic) => ({
  en: `Explain how climate and site conditions (including soils where relevant) influence grape growing and wine style in ${topic.en}.`,
  cn: `请说明气候与园地条件（包括土壤，如相关）如何影响${topic.cn}的葡萄种植与葡萄酒风格。`,
});

const varietyQuestion = (topic, grape) =>
  grape
    ? {
        en: `Describe the grape characteristics of ${topic.en} and explain how winemaking choices shape its principal wine styles.`,
        cn: `请描述${topic.cn}的品种特性，并说明酿酒选择如何塑造其主要葡萄酒风格。`,
      }
    : {
        en: `Identify the principal grape varieties of ${topic.en}, describe their characteristics, and explain how they and winemaking choices shape wine style.`,
        cn: `请指出${topic.cn}的主要葡萄品种，说明其品种特性，并解释它们与酿酒选择如何塑造葡萄酒风格。`,
      };

const practiceQuestion = (topic) => ({
  en: `Explain the viticultural and winemaking options used to produce quality wines in ${topic.en}, and how these choices affect wine style.`,
  cn: `请说明${topic.cn}用于酿造优质葡萄酒的种植与酿酒选择，以及这些选择如何影响葡萄酒风格。`,
});

const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

const slug = (text) =>
  (text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 48);

const findTopicForQuestion = (topics, questionEn) =>
  topics.find((t) => t.questions.some((q) => q.question?.en === questionEn));

const stemFor = (topic, grape, kind) => {
  if (kind === "climate") return climateQuestion(topic);
  if (kind === "variety") return varietyQuestion(topic, grape);
  if (kind === "practice") return practiceQuestion(topic);
  return factorsQuestion(topic, grape);
};

const essayContext = (path) => ({
  grapeName: isGrapeTopic(path) ? path[path.length - 1] : null,
  regionKey: path[path.length - 1],
});

const questionsForKind = (topicEntry, kind) => {
  const grouped = { climate: [], variety: [], practice: [], all: topicEntry.questions };
  topicEntry.questions.forEach((q) => {
    const cat = categorize(q);
    if (cat === "climate") grouped.climate.push(q);
    if (cat === "variety" || cat === "character") grouped.variety.push(q);
    if (cat === "viticulture" || cat === "winemaking") grouped.practice.push(q);
  });
  if (kind === "climate") return grouped.climate.length ? grouped.climate.concat(topicEntry.questions.slice(0, 6)) : topicEntry.questions;
  if (kind === "variety") return grouped.variety.length ? grouped.variety.concat(topicEntry.questions.slice(0, 8)) : topicEntry.questions;
  if (kind === "practice") return grouped.practice.length ? grouped.practice.concat(topicEntry.questions.slice(0, 8)) : topicEntry.questions;
  return topicEntry.questions;
};

const buildTopicEssay = (topicEntry, kind) => {
  const topic = topicName(topicEntry.path);
  const grape = isGrapeTopic(topicEntry.path);
  const key = pathKey(topicEntry.path);
  const pool = questionsForKind(topicEntry, kind);
  if (kind === "climate" && pool.length < 2) return null;
  if (kind === "variety" && pool.length < 2) return null;
  if (kind === "practice" && pool.length < 2) return null;
  return makeEssay(
    `essay-${key}-${kind === "factors" ? "factors" : kind}`,
    topic,
    stemFor(topic, grape, kind === "factors" ? "factors" : kind),
    pool,
    essayContext(topicEntry.path)
  );
};

const buildAdaptiveEssay = (seed, topicEntry, extraMcqs, origin) => {
  const topic = topicName(topicEntry.path);
  const grape = isGrapeTopic(topicEntry.path);
  const kind = categorize(seed);
  const stemKind = kind === "style" || kind === "character" ? "factors" : kind === "winemaking" || kind === "viticulture" ? "practice" : kind;
  const stem = stemFor(topic, grape, stemKind === "climate" || stemKind === "variety" || stemKind === "practice" ? stemKind : "factors");

  const seen = new Set();
  const related = [];
  [seed, ...extraMcqs, ...topicEntry.questions].forEach((q) => {
    const id = q?.question?.en;
    if (!id || seen.has(id)) return;
    seen.add(id);
    related.push(q);
  });

  const essay = makeEssay(
    `essay-adaptive-${origin}-${slug(seed.question.en)}`,
    topic,
    stem,
    related.slice(0, 20),
    essayContext(topicEntry.path)
  );
  if (!essay) return null;
  return {
    ...essay,
    origin,
    sourceQuestionEns: related.slice(0, 8).map((q) => q.question.en),
  };
};

export const refreshEssayAnswer = (essay, questionFiles) => {
  if (!essay) return essay;
  const topics = collectTopics(questionFiles);
  let related = [];
  let grapeName = null;
  let regionKey = null;

  const practice = (essay.id || "").match(/^essay-(.+)-(factors|climate|variety|practice)$/);
  if (practice) {
    const key = practice[1];
    const path = key.split("/");
    grapeName = path[0] === "Grapes" ? path[path.length - 1] : null;
    regionKey = path[path.length - 1];
    const topicEntry = topics.find((t) => pathKey(t.path) === key);
    if (topicEntry) related = topicEntry.questions;
  }

  if (essay.sourceQuestionEns?.length) {
    const byEn = new Map();
    topics.forEach((t) => t.questions.forEach((q) => byEn.set(q.question?.en, q)));
    const sourced = essay.sourceQuestionEns.map((en) => byEn.get(en)).filter(Boolean);
    const topicEntry = findTopicForQuestion(topics, essay.sourceQuestionEns[0]);
    if (topicEntry) {
      grapeName = grapeName || (isGrapeTopic(topicEntry.path) ? topicEntry.path[topicEntry.path.length - 1] : null);
      regionKey = regionKey || topicEntry.path[topicEntry.path.length - 1];
      related = [...sourced, ...topicEntry.questions.filter((q) => !sourced.includes(q))];
    } else if (sourced.length) {
      related = sourced;
    }
  }

  if (!related.length) return essay;
  return {
    ...essay,
    bullets: buildModelAnswer(related, { grapeName, regionKey, topic: essay.topic }),
    answerVersion: 2,
  };
};

export const generateOneEssay = (questionFiles, options = {}) => {
  const {
    mistakes = [],
    starredIds = [],
    excludeIds = [],
    excludeSourceEns = [],
  } = options;

  const topics = collectTopics(questionFiles);
  const excluded = new Set(excludeIds);
  const usedSources = new Set(excludeSourceEns);
  const starredSet = new Set(starredIds);

  const allMcqs = topics.flatMap((t) => t.questions);
  const mistakeSeeds = mistakes
    .map((m) => m?.question)
    .filter((q) => q?.question?.en && !usedSources.has(q.question.en));
  const starredSeeds = allMcqs.filter(
    (q) => starredSet.has(q.question?.en) && !usedSources.has(q.question.en)
  );

  const tryAdaptive = (seeds, origin) => {
    const unused = seeds.filter((q) => !excluded.has(`essay-adaptive-${origin}-${slug(q.question.en)}`));
    if (unused.length === 0) return null;
    const seed = pickRandom(unused);
    const topicEntry = findTopicForQuestion(topics, seed.question.en);
    if (!topicEntry) return null;
    const extra = [...mistakeSeeds, ...starredSeeds].filter((q) =>
      topicEntry.questions.some((tq) => tq.question?.en === q.question?.en)
    );
    const essay = buildAdaptiveEssay(seed, topicEntry, extra, origin);
    if (essay && !excluded.has(essay.id)) return essay;
    return null;
  };

  if (mistakeSeeds.length && (starredSeeds.length === 0 || Math.random() < 0.65)) {
    const essay = tryAdaptive(mistakeSeeds, "mistake");
    if (essay) return essay;
  }
  if (starredSeeds.length) {
    const essay = tryAdaptive(starredSeeds, "starred");
    if (essay) return essay;
  }
  if (mistakeSeeds.length) {
    const essay = tryAdaptive(mistakeSeeds, "mistake");
    if (essay) return essay;
  }

  const kinds = ["factors", "climate", "variety", "practice"];
  const shuffledTopics = [...topics].sort(() => Math.random() - 0.5);
  for (const t of shuffledTopics) {
    const shuffledKinds = [...kinds].sort(() => Math.random() - 0.5);
    for (const kind of shuffledKinds) {
      const essay = buildTopicEssay(t, kind);
      if (essay && !excluded.has(essay.id)) {
        return { ...essay, origin: "practice", sourceQuestionEns: [] };
      }
    }
  }

  return null;
};

export const generateEssayQuestions = (questionFiles) => {
  const topics = collectTopics(questionFiles);
  const byKey = Object.fromEntries(topics.map((t) => [pathKey(t.path), t]));
  const essays = [];

  topics.forEach((topicEntry) => {
    const overview = buildTopicEssay(topicEntry, "factors");
    if (overview) essays.push(overview);
    ["climate", "variety", "practice"].forEach((kind) => {
      if (topicEntry.questions.length >= 8) {
        const extra = buildTopicEssay(topicEntry, kind);
        if (extra) essays.push(extra);
      }
    });
  });

  COMPARISON_PAIRS.forEach(([pathA, pathB]) => {
    const a = byKey[pathKey(pathA)];
    const b = byKey[pathKey(pathB)];
    if (!a || !b) return;
    const topicA = topicName(pathA);
    const topicB = topicName(pathB);
    const combined = [...a.questions.slice(0, 10), ...b.questions.slice(0, 10)];
    const extra = makeEssay(
      `essay-compare-${pathKey(pathA)}-${pathKey(pathB)}`,
      { en: `${topicA.en} vs ${topicB.en}`, cn: `${topicA.cn} 与 ${topicB.cn}` },
      {
        en: `Compare and contrast the wines of ${topicA.en} and ${topicB.en}, with reference to grape characteristics, climate, winemaking and wine style.`,
        cn: `请比较${topicA.cn}与${topicB.cn}的葡萄酒，涉及品种特性、气候、酿酒工艺与风格。`,
      },
      combined,
      { grapeName: null, regionKey: null }
    );
    if (extra) essays.push(extra);
  });

  return essays;
};
